import { render } from "./Test.html?vue&type=template&id=a9b89784&scoped=true&ts=true"
import script from "./Test.ts?vue&type=script&lang=ts"
export * from "./Test.ts?vue&type=script&lang=ts"

import "./Test.css?vue&type=style&index=0&id=a9b89784&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b89784"]])

export default __exports__